import {NgxTranslation} from '@ngx-translations/translations.interfaces';

export interface NgxNotification {
    text: string | NgxTranslation;
    type: NgxNotificationType;

    id?: string;
    title?: string | NgxTranslation;
    timeout?: number;
    closable?: boolean;
    icon?: string;

    destroy?: () => void;
}

export const enum NgxNotificationType {
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
    Info = 'info'
}

export class NgxNotificationOptions {
    timeout?: number;

    closable?: boolean;

    titles?: {
        success?: string;
        error?: string;
        warning?: string;
        info?: string;
    };

    icons?: {
        success?: string;
        error?: string;
        warning?: string;
        info?: string;
    };
}
